import INTRODUCTION from "../../components/Introduction/Introduction"
import TESTIMONIALS from "../../components/Testimonials/Testimonials"
import CONTACT from '../../components/Contact/Contact'
import AWARDS from "../../pages/awards/Awards"

const home = () => {
  return (
    <div>
      <INTRODUCTION/>
      <AWARDS/>
      <TESTIMONIALS/>
      <CONTACT/>
    </div>
  )
}

export default home